export default function lottieAnimation() {
  window.lottieAnimation = bodymovin.loadAnimation({
    container: document.getElementById('anim'),
    renderer: 'svg',
    loop: false,
    autoplay: false,
    path:
      window.innerWidth > 720
        ? 'assets/img/Envol_espace_Animation_Landing_Ecran_03.json'
        : 'assets/img/Envol_espace_Animation_Landing_Ecran_03_Mobile.json',
  });

  window.lottieAnimation.addEventListener('enterFrame', displayCta);

  function displayCta(e) {
    const cta = document.querySelector('.cta');
    if (cta) {
      if (e.currentTime > 320) {
        window.lottieAnimation.removeEventListener('enterFrame', displayCta);
        cta.classList.add('active');
      }
    }
  }
}
